import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import v2Styles from "../../../v2Styles.module.css";

export default function EditableTextCell({ value = "", dataObj = {}, showDeleteIcon = false, onDelete, showAddIcon = false, onAdd, onUpdate, cellStyle = {}, containerStyle = { whiteSpace: "pre-wrap" }, textAreaStyle = {}, cellBackground = "transparent", visibleBackground = "#f5f5f5", multiLine = false, onMove, showMoveIcons = false, showUpArrow = true, showDownArrow = true, isDisabled, ...props }) {
  const [visible, setVisible] = React.useState(false);
  const [textVal, setTextVal] = useState(value ? value : "");
  const ref = useRef();

  useEffect(() => {
    setTextVal(value);
  }, [value])

  const onClick = () => {
    if (isDisabled) return;
    setVisible(true);
    if (ref && ref.current) {
      ref.current.focus();
      ref.current.setSelectionRange(textVal.length, textVal.length)
    }
  }

  const updateRecord = () => {
    if (value !== textVal && onUpdate) {
      let dataVal = {
        ...dataObj,
        value: textVal
      }
      onUpdate(dataVal);
    }
  }

  return (
    <td style={{ ...cellStyle, position: "relative", background: !isDisabled && visible ? visibleBackground : cellBackground }} {...props} onClick={() => onClick()} onMouseEnter={() => setVisible(true)} onMouseLeave={() => { setVisible(false); updateRecord(); }}>
      <div style={{ height: "inherit", width: "inherit", minHeight: "1lh" }} onClick={(e) => e.stopPropagation()}>
        {!isDisabled && visible ? (
          <textarea
            ref={ref}
            {...(!multiLine ? { onKeyDown: (e) => e.key === "Enter" && e.preventDefault() } : {})}
            autoComplete="none"
            style={{ width: "100%", fieldSizing: "content", border: "0px", padding: "0px", resize: "none", lineHeight: 1.5, display: "block", background: "transparent", ...textAreaStyle }}
            onChange={(e) => setTextVal(e.target.value)} value={textVal}></textarea>
        ) : <span style={containerStyle}>{textVal.endsWith("\n") ? textVal + "\u200B" : textVal}</span>}
      </div>
      {!isDisabled && visible && (showDeleteIcon || showAddIcon || showMoveIcons) ? (
        <div className="d-flex align-items-center justify-content-end" style={{ position: "absolute", right: "5px", bottom: "5px", gap: "5px", background: "#fff", borderRadius: "5px", padding: "2px 4px", boxShadow: "0px 0px 2px 1px #ddd" }}>
          {showMoveIcons ? (<>
            <Tooltip title="Move up">
              <span>
                <IconButton disabled={!showUpArrow} onClick={(e) => { e.stopPropagation(); e.preventDefault(); onMove("up") }} className={`${v2Styles.IconBtn} ${v2Styles.SecondaryColor} p-0`}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
                    <path fill="currentColor" d="M297.4 201.4C309.9 188.9 330.2 188.9 342.7 201.4L502.7 361.4C515.2 373.9 515.2 394.2 502.7 406.7C490.2 419.2 469.9 419.2 457.4 406.7L320 269.3L182.6 406.6C170.1 419.1 149.8 419.1 137.3 406.6C124.8 394.1 124.8 373.8 137.3 361.3L297.3 201.3z" />
                  </svg>
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Move down">
              <span>
                <IconButton disabled={!showDownArrow} onClick={(e) => { e.stopPropagation(); e.preventDefault(); onMove("down") }} className={`${v2Styles.IconBtn} ${v2Styles.SecondaryColor} p-0`}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "16px", width: "16px" }}>
                    <path fill="currentColor" d="M297.4 438.6C309.9 451.1 330.2 451.1 342.7 438.6L502.7 278.6C515.2 266.1 515.2 245.8 502.7 233.3C490.2 220.8 469.9 220.8 457.4 233.3L320 370.7L182.6 233.4C170.1 220.9 149.8 220.9 137.3 233.4C124.8 245.9 124.8 266.2 137.3 278.7L297.3 438.7z" />
                  </svg>
                </IconButton>
              </span>
            </Tooltip>
          </>) : null}
          {showAddIcon ? (
            <IconButton onClick={(e) => { e.stopPropagation(); onAdd() }} className={`${v2Styles.IconButton} ${v2Styles.PrimaryColor} p-0`} style={{ height: "auto" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "18px", width: "18px" }}>
                <path fill="currentColor" d="M352 128C352 110.3 337.7 96 320 96C302.3 96 288 110.3 288 128L288 288L128 288C110.3 288 96 302.3 96 320C96 337.7 110.3 352 128 352L288 352L288 512C288 529.7 302.3 544 320 544C337.7 544 352 529.7 352 512L352 352L512 352C529.7 352 544 337.7 544 320C544 302.3 529.7 288 512 288L352 288L352 128z" />
              </svg>
            </IconButton>
          ) : null}
          {showDeleteIcon ? (
            <IconButton onClick={(e) => { e.stopPropagation(); onDelete() }} className={`${v2Styles.IconButton} ${v2Styles.DangerColor} p-0`} style={{ height: "auto" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "18px", width: "18px" }}>
                <path fill="currentColor" d="M232.7 69.9L224 96L128 96C110.3 96 96 110.3 96 128C96 145.7 110.3 160 128 160L512 160C529.7 160 544 145.7 544 128C544 110.3 529.7 96 512 96L416 96L407.3 69.9C402.9 56.8 390.7 48 376.9 48L263.1 48C249.3 48 237.1 56.8 232.7 69.9zM512 208L128 208L149.1 531.1C150.7 556.4 171.7 576 197 576L443 576C468.3 576 489.3 556.4 490.9 531.1L512 208z" />
              </svg>
            </IconButton>
          ) : null}
        </div>
      ) : null}
    </td>
  )
}
